module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message_sent":"Message sent","mail":"E-mail","sms":"Text message"}}')
  delete Component.options._Ctor
}
